<section>
  <h3>{{ 'USER_REQUESTS.AI_TRANSLATION.HEADER' | translate }}</h3>

  <ul>
    <li>{{ 'USER_REQUESTS.AI_TRANSLATION.OPTION_1' | translate }}</li>
    <li>{{ 'USER_REQUESTS.AI_TRANSLATION.OPTION_2' | translate }}</li>
    <li>{{ 'USER_REQUESTS.AI_TRANSLATION.OPTION_3' | translate }}</li>
  </ul>

  <p>{{ 'USER_REQUESTS.AI_TRANSLATION.INFO' | translate }}</p>

  <nz-row [nzAlign]="'middle'">
    <nz-col [nzSpan]="8">
      <label>{{ 'USER_REQUESTS.AI_TRANSLATION.LANGUAGE_LABEL' | translate }}</label>
    </nz-col>

    <nz-col [nzSpan]="16">
      <nz-select
        [ngModel]="language"
        (ngModelChange)="onLanguageChange($event)"
        [nzDisabled]="!canRequest"
      >
        <nz-option
          *ngFor="let lang of languages"
          [nzLabel]="(lang | uppercase) | translate"
          [nzValue]="lang"
        ></nz-option>
      </nz-select>
    </nz-col>
  </nz-row>
</section>
